interface User {
  email: string;
  firstName?: string;
  lastName?: string;
}

export const getUserInitials = (user: User) => {
  if (user.firstName && user.lastName) {
    return `${user.firstName[0]}${user.lastName[0]}`;
  }

  if (user.firstName) {
    return user.firstName[0];
  }

  const splitedEmail = user.email.slice(0, user.email.indexOf('@')).split(/[_\-\.]{1,}/);

  if (splitedEmail.length >= 2) {
    return `${splitedEmail[0][0]}${splitedEmail[1][0]}`; // first letter of string
  }

  return splitedEmail[0][0]; // first letter of string
};
